module.exports = __webpack_public_path__ + "static/profile_picture_destroyed_hair-422bc727729bbde1a023ee6b523d184e.png";